import { useRef, type ReactNode } from "react";
import dayjs from "dayjs";

const CustomDatePicker = (props: {
    view: ReactNode;
    selectedDate: number | null;
    setSelectedDate: (newDate: number) => void;
    minDate?: number | null;
    maxDate?: number | null;
}) => {
    const { view, selectedDate, setSelectedDate, minDate, maxDate } = props;
    const inputRef = useRef<HTMLInputElement | null>(null);

    // These must be in the specified format to work with input, if they're null set them as undefined
    const value = selectedDate ? dayjs(selectedDate).format("YYYY-MM-DD") : undefined;
    const min = minDate ? dayjs(minDate).format("YYYY-MM-DD") : undefined;
    const max = maxDate ? dayjs(maxDate).format("YYYY-MM-DD") : undefined;

    return (
        <div
            className="relative cursor-pointer"
            onClick={() => {
                if (inputRef.current) {
                    inputRef.current.showPicker();
                }
            }}
        >
            {view}
            <input
                ref={inputRef}
                type="date"
                value={value}
                min={min}
                max={max}
                onChange={e => {
                    setSelectedDate(dayjs(e.target.value).startOf("day").valueOf());
                }}
                className="pointer-events-none absolute left-1/2 top-1/2 h-0 w-0 -translate-x-1/2 -translate-y-1/2 transform opacity-0"
                tabIndex={-1}
            />
        </div>
    );
};

export default CustomDatePicker;
